var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.src),expression:"src",arg:"background-image"}],staticClass:"pic-bg",on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }